module.exports = __webpack_public_path__ + "fonts/Barlow-Light.16073b8d.eot";